import Opener2 from "../../components/opener2/opener2.component"
import Navbar from "../../navbar/navbar.component"
import CostSaving from "../../components/cost-saving/cost-saving.component"
import FAQ from "../../components/faq/faq.component"
import BookNow from "../../components/book-now/book-now.component"
import Footer from "../../components/footer/footer.component"
import "./tutoring2.styles.scss"
import { useEffect } from "react"

function Tutoring2() {


  return (
    <>
      <div className="tutoring2-wrapper">
        <div className="content-wrapper">
          <Navbar homepage_disabled={true} />
          <section>
            <Opener2 />
          </section>
          <section>
            <CostSaving />
          </section>
          <section>
            <FAQ />
          </section>
          <section>
            <BookNow />
          </section>
        </div>
        <Footer />
      </div>
    </>
  )
}

export default Tutoring2
